import { ChatType } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/index.js'

interface Props {
  hasOlderMessages: boolean
  isLoading: boolean
  type: ChatType
}

export const ChatMessagesListHeader = ({
  hasOlderMessages,
  isLoading,
  type,
}: Props) => {
  if (type === ChatType.Direct && !hasOlderMessages && !isLoading) {
    return (
      <div className="flex flex-col items-center justify-end h-full">
        {/* eslint-disable-next-line react/jsx-no-literals */}
        <div className="bg-surface-subdued p-2 text-xs rounded-lg italic inline-block max-w-[80%] sm:max-w-[50%] text-center text-content-muted">
          👋{' '}
          <T
            id="Messaging.Chat.StartOfConversation"
            defaultMessage="Start of the conversation"
          />
        </div>
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-end h-full">
        <SvgIcon className="animate-spin h-7 w-7" name="spinner" />
      </div>
    )
  }

  return null
}
